export default "__VITE_ASSET__Cea4vslA__"